import type { TypeFormElementOrList } from '../../../types/form';

import addClass from '../../../general/class/addClass';
import hasAttr from '../../../general/attr/hasAttr';

// ----------------------------------------------------------------------------

function formValidationHandler(forms: TypeFormElementOrList): void {
    const elements = Array.isArray(forms) ? forms : [forms];

    for (const elForm of elements) {
        const listener = function (evt: Event): void {
            if (!elForm.checkValidity()) {
                evt.preventDefault();
            }

            if (hasAttr(elForm, 'novalidate')) {
                addClass(elForm, 'was-validated');
            }
        };

        elForm.addEventListener('submit', listener, false);
    }
}

// ----------------------------------------------------------------------------

export default formValidationHandler;
